import { motion } from 'framer-motion';
import { AlertCircle, Info, CheckCircle2 } from 'lucide-react';
import type { ReactNode } from 'react';

const ICONS = {
  danger: <AlertCircle className="w-5 h-5 text-rose-500" />,
  info: <Info className="w-5 h-5 text-zinc-400" />,
  success: <CheckCircle2 className="w-5 h-5 text-emerald-500" />,
};

export function Alert({
  tone = 'info',
  children,
}: {
  tone?: 'danger' | 'info' | 'success';
  children: ReactNode;
}): JSX.Element {
  const toneClasses = {
    danger:
      'bg-rose-50 border-rose-200 text-rose-700 dark:bg-rose-500/10 dark:border-rose-500/20 dark:text-rose-200',
    info: 'bg-zinc-100 border-zinc-200 text-zinc-700 dark:bg-zinc-800/50 dark:border-white/10 dark:text-zinc-300',
    success:
      'bg-emerald-50 border-emerald-200 text-emerald-700 dark:bg-emerald-500/10 dark:border-emerald-500/20 dark:text-emerald-200',
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className={`flex items-start gap-3 p-4 rounded-[16px] border ${toneClasses[tone]}`}
      role={tone === 'danger' ? 'alert' : 'status'}
    >
      <div className="shrink-0 mt-0.5">{ICONS[tone]}</div>
      <div className="text-sm leading-relaxed">{children}</div>
    </motion.div>
  );
}
